import { transformedImageUrl, imageSrcSet } from "@/lib/image-url";

type PortraitSubject = {
  portrait: string;
  name: string;
  portraitPosition?: string | null;
  portraitZoom?: number | null;
};

type Props = {
  p: PortraitSubject;
  className?: string;
  loading?: "eager" | "lazy";
};

export function PortraitImage({ p, className = "w-full", loading = "lazy" }: Props) {
  if (!p.portrait) {
    return (
      <div className={`${className} bg-muted flex items-center justify-center text-xs text-muted-foreground italic`}>
        Kein Portrait
      </div>
    );
  }
  return (
    <div className={`${className} bg-muted`}>
      <img
        src={transformedImageUrl(p.portrait, { width: 600, quality: 70, resize: "contain" })}
        srcSet={imageSrcSet(p.portrait, [400, 600, 900], { quality: 70, resize: "contain" })}
        sizes="(min-width: 1024px) 25vw, (min-width: 640px) 33vw, 50vw"
        alt={`Porträt von ${p.name}`}
        loading={loading}
        decoding="async"
        draggable={false}
        className="w-full h-auto object-contain pointer-events-none"
        onError={(e) => ((e.currentTarget as HTMLImageElement).style.opacity = "0.2")}
      />
    </div>
  );
}
